import UserThumbnail from '../../assets/user-thumbnail.svg';
import UserIcon from '../../assets/user-icon.svg';
import { DomainUser } from '@raydiant/api-client-js';
import Text from '@raydiant/raydial/components/Text';

interface UserCardProps {
  user: DomainUser;
  onClick: (userId: string) => void;
}

const UserCard = ({ user, onClick }: UserCardProps) => {
  return (
    <div
      className="h-[185px] rounded-[20px] shadow border-2 border-grey-100 flex-col justify-start items-start inline-flex cursor-pointer"
      onClick={() => onClick(user.id || '')}
    >
      <div
        className="w-[216px] h-[125px] p-4 rounded-t-[20px] flex-col justify-between items-end flex bg-black bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${UserThumbnail})` }}
      ></div>
      <div className="w-[216px] h-[60px] px-4 bg-white rounded-b-[20px] flex-col justify-center items-start gap-2.5 flex">
        <div className="self-stretch justify-start items-center gap-2 inline-flex">
          <div className="w-6 h-6 relative">
            <div
              className="w-6 h-6 left-0 top-0 absolute rounded-md bg-center bg-no-repeat bg-cover"
              style={{ backgroundImage: `url(${UserIcon})` }}
            />
          </div>
          <div className="grow shrink basis-0 text-gray-600 break-all line-clamp-2">
            <Text variant="body">{user.name}</Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
